<template>
  <Section>
    <template v-slot:section-header>
      <h5 class="title">ข้อมูลผู้ใช้</h5>
    </template>
    <template v-slot:section-body>
      <form @submit.prevent>
        <div class="row">
          <div class="col-12 order-last col-md-7 order-md-first">
            <FormGroup>
              <h5 class="name">ชื่อ</h5>
              <input
                type="text"
                :value="user.name"
                placeholder="ชื่อผู้ใช้"
                class="form-control"
                :class="{ 'is-invalid': saveUserStateError.name }"
                @input="$emit('update:user', { ...user, name: $event.target.value })"
                @blur="validateName"
                @keyup="validateName"/>
              <div class="invalid-feedback">{{ saveUserStateError.name }}</div>
            </FormGroup>
            <FormGroup>
              <h5 class="name">อีเมล</h5>
              <input
                placeholder="example@gmail.com"
                type="email"
                :value="user.email"
                class="form-control"
                :class="{ 'is-invalid': saveUserStateError.email }"
                @input="$emit('update:user', { ...user, email: $event.target.value })"
                @blur="validateEmail"
                @keyup="validateEmail"/>
              <div class="invalid-feedback">{{ saveUserStateError.email }}</div>
            </FormGroup>
            <FormGroup>
              <h5 class="name">รหัสผ่าน</h5>
              <input
                placeholder="รหัสผ่าน"
                type="password"
                :value="user.password"
                class="form-control"
                @input="$emit('update:user', {...user, password: $event.target.value,})"
                :class="{ 'is-invalid': saveUserStateError.password }"
                @keyup="validatePassword"
                @blur="validatePassword"/>
              <div class="invalid-feedback">
                {{ saveUserStateError.password }}
              </div>
            </FormGroup>
            <FormGroup>
              <h5 class="name">ยืนยันรหัสผ่าน</h5>
              <input
                placeholder="ยืนยันรหัสผ่าน"
                type="password"
                class="form-control"
                :class="{ 'is-invalid': saveUserStateError.confirmPassword }"
                @input="$emit('update:user', { ...user, confirmPassword: $event.target.value })"
                @blur="validateConfirmPass"
                @keyup="validateConfirmPass"/>
              <div class="invalid-feedback">
                {{ saveUserStateError.confirmPassword }}
              </div>
            </FormGroup>
            <FormGroup>
              <h5 class="name">บทบาท</h5>
              <select
                @change="$emit('update:user', { ...user, roleId: $event.target.value })"
                value="user.roleId"
                class="form-control">
                <option value="editor" selected="selected">ผู้จัดการคอนเทนท์</option>
                <option value="admin">ผู้ดูแลระบบ</option>
              </select>
            </FormGroup>
          </div>
          <div class="col-12 order-first col-md-5 col-lg-3 order-md-last">
            <FormGroup>
              <UserImageContainer :image.sync="user.displayImage" />
            </FormGroup>
          </div>
        </div>
      </form>
    </template>
  </Section>
</template>

<script>
import Section from '@/components/Section.vue';
import FormGroup from '@/components/FormGroup.vue';
import UserImageContainer from './UserImageContainer.vue';

export default {
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    saveUserStateError: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Section,
    UserImageContainer,
    FormGroup,
  },
  methods: {
    validateName(event) {
      if (!event.target.value) {
        this.$emit('update:saveUserStateError', {
          ...this.saveUserStateError,
          name: 'กรุณากรอกชื่อที่ต้องการใช้แสดงผล',
        });
      } else {
        this.$emit('update:saveUserStateError', {
          ...this.saveUserStateError,
          name: null,
        });
      }
    },
    validateEmail(event) {
      if (!event.target.value) {
        this.$emit('update:saveUserStateError', {
          ...this.saveUserStateError,
          email: 'กรุณากรอกอีเมลของคุณ',
        });
      } else if (!event.target.value.match(this.mailformat)) {
        this.$emit('update:saveUserStateError', {
          ...this.saveUserStateError,
          email: 'กรุณากรอกอีเมลให้ถูกต้อง ตัวอย่าง: example@ex.com',
        });
      } else {
        this.$emit('update:saveUserStateError', {
          ...this.saveUserStateError,
          email: null,
        });
      }
    },
    validatePassword(event) {
      if (!event.target.value.match(this.englishAlphabets) || event.target.value.length < 8) {
        this.$emit('update:saveUserStateError', {
          ...this.saveUserStateError,
          password: 'กรุณาใช้รหัสผ่านที่มีตัวอักษรภาษาอังกฤษ และยาวไม่ต่ำกว่า 8 ตัว',
        });
      } else {
        this.$emit('update:saveUserStateError', {
          ...this.saveUserStateError,
          password: null,
        });
      }
    },
    validateConfirmPass(event) {
      if (!event.target.value || this.user.password !== event.target.value) {
        this.$emit('update:saveUserStateError', {
          ...this.saveUserStateError,
          confirmPassword: 'กรุณายืนยันรหัสผ่านให้ถูกต้อง',
        });
      } else {
        this.$emit('update:saveUserStateError', {
          ...this.saveUserStateError,
          confirmPassword: null,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/form.scss';
@import './src/assets/scss/themes/components/section-container.scss';
</style>
